export const CLASSIFIEDS_VIEW = { list: 2, grid: 0, clothes: 1, map: 'map' };
